

import {  Link } from "react-router-dom"
import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'
import {SVADFORM,SV_SERVICES, SV_SERVER_ADDRESS, SV_URL} from '../../../constants'
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';
import { DatePicker } from 'antd';
import moment from 'moment'

/*reloadPage
import {loadCountriesAction} from '../../../actions'
*/
/*
import {prfLoadPrdAdDataDB as loadPrdAdDataDB } from '../../../redux/svractions/svaddressdetActions'
*/
const _ = require('lodash')
const React = require('react')
const {connect}  = require("react-redux")




const isdcodeTypes = [{
    name:'United States Of America(+1)',
    value:'+1'
  },{
    name:'Australia(+61)',
    value:'61'
},{
    name:'Spain(+34)',
    value:'34'
  }]
const countryTypes = [{
    name:'United States Of America',
    value:'USA'
  },{
    name:'Australia',
    value:'AUS'
},{
    name:'Spain',
    value:'ES'
  
  }]
const genderTypes = [{
    name:'CL_MALE',
    value:'MALE'
  },{
    name:'CL_FEMALE',
    value:'FEMALE'
  
  }]

const svsubmit =(values)=>{
    let me = this
  console.log('sv submit callback')
  console.log(values)
/*

  Promise.all([svNotifySavePromise(values)]).then((ar)=>{
      console.log('sv got promise data')

      let rs= ar[0]
      console.log(rs)
        if(rs.data.value.payload.gene){
           // me.props.geneReceptorActivate(rs.data.value.payload.gene, rs.data.value.payload)
        }
   

  })
  */
  //this.props.handleSubmit(this.props.submit('SVClassifierForm'))
}


const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  const renderFieldDup = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          {touched && error &&  <input className="sverr form-control" {...input} type={type} placeholder={label} /> }
          {touched && !error &&  <input className="svgreen form-control" {...input} type={type} placeholder={label} /> }
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  /*
const renderSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )
  const renderTravelSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )

  const renderBookingAgentType = ({input, data})=> (
      <SelectList {...input } onBlur={() =>input.onBlur()} data={data} />
  )
*/
let dcountries = [{
    name:'United States Of America',
    value:'usa'

  },{
    name:'France',
    value:'France'
  },{

    name:'China',
    value:'China'
},{
    name:'Mexico',
    value:'Mexico'
  
  }]

let genes = [{
    name:'add_step',
    value:'add_step'

  },{
    name:'multiply_seq_step',
    value:'multiply_seq_step'
  },{

    name:'sq_step',
    value:'sq_step'
},{
    name:'sr_step',
    value:'sr_step'
  
  }]


let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }


let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            return errors
        }
        if(!formData.name){
            errors.name= 'Required'
        }
        if(!formData.fname){
            errors.fname= 'Required'
        }
        if(!formData.lname){
            errors.lname= 'Required'
        }
        if(!formData.email){
            errors.email= 'Required'
        }
        if(!formData.address){
            errors.address= 'Required'
        }
        if(!formData.city){
            errors.city= 'Required'
        }
       
        if(!formData.zipcode){
            errors.zipcode= 'Required'
        }
        if(!formData.country){
            errors.country= 'Required'
        }
        if(!formData.isdcode){
            errors.isdcode= 'Required'
        }
       
        /*
         if(!formData.country){
            errors.country= 'Required'
        }
         if(!formData.state){
            errors.state= 'Required'
        }
        if(!formData.isdcode){
            errors.isdcode= 'Required'
        }
        
        if(!formData.phone){
            errors.phone= 'Required'
        }
        */
       
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
        /*
        if(formData.lname <2){
            o.gene ='We expect gene to br more tham 5'
        }
        */
        return o
    }


class CreateAddressFormFormBus extends React.Component{

    constructor(props){
        
        super(props)
        let me = this
        this.svcadCurryCom = this.svcadCurryCom.bind(me)
        this.renderCad = this.renderCad.bind(me)
        this.loadGene = this.loadGene.bind(me)
        this.reloadPageSV = this.reloadPageSV(me)
        this.ddChange = this.ddChange.bind(me) 
        this.cancelPage = this.cancelPage.bind(me) 
        this.dcountryChange = this.dcountryChange.bind(me)
        this.getAppDetails = this.getAppDetails.bind(me)
       
    }
    
    reloadPageSV=(cid)=>(e)=>{
        console.log('sv****Got the page reloadPageSV needs customerId')
        console.log(cid)
       // history.back(-1)
       

      // history.push(`/myaccountSV/6/svaddress/-1`)
        

    }

    getAppDetails(paramQSpaceId){
        //for edit we have id make it -1 for create

        let id = -1
        if(paramQSpaceId ){
            id  = parseInt(paramQSpaceId)
        }
        console.log("id* addressr det or cerate ******", id)
       //loadAddressDet(id)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    cancelPage(){
        console.log('cancel page')

    }
 loadGene(e){
        console.log(e)
    }


    dcountryChange(e){

        console.log(e)
       // console.log('gene name:' +this.props.dcountry)

        let o = _.findWhere(dcountries,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             dcountry:o.name
        })

    }
    
    ddChange(e){
        
        console.log(e)
        console.log('gene name:' +this.props.gene)

        let o = _.findWhere(genes,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }
    /*svf6 start*/
    svcadCurryCom = (param1, ctxThis) => (o) => {
        console.log("*******svj22****curry** START")
        console.log(param1)

        console.log(ctxThis)

        console.log(o)
        const { input: { onChange, value } } = o
        console.log("*******svj22****redux vaalue**")
        console.log(value)
        let STARTDATE_ITN_TZAWARE_EST = "2025-11-25"

        let vob = null
        let vob_date = null
        let mo_ss = moment(STARTDATE_ITN_TZAWARE_EST, 'YYYY-MM-DD');
        let mofval = null
        let mofmom = null
        if(value && _.isString(value) && value.length <=1){
            vob_date = moment()
        } else if(value && _.isString(value) && value.length > 1){
            let d_s = value
            vob_date = moment(d_s)
            mofmom  = moment(d_s)
        } else if(value && _.isObject(value)){
            vob = value
            vob_date = value._d
            mofmom  = moment(vob_date)
        }else if (value == null){
            mofval = mo_ss
            mofmom = moment()

        }else{
            console.log('svJ30 ***bad valeue CAUSE ISSUE***')
            console.log(value)
             vob = value
             vob_date = value._d
             mofmom  = moment(vob_date)
        }
        console.log(vob_date)
         STARTDATE_ITN_TZAWARE_EST = "2025-11-25"

        
        /*
        if (value != null) {
            mofval = moment(vob_date)
            let mofval_str = mofval.format('YYYY-MM-DD')

            console.log("*******svj22****mofval_stre**")

            console.log(mofval_str)
            this.setState({'svdob':mofval_str})



           // let mom_value = !value ? mo_ss : mofval_str
           mofval = !value ? mo_ss : mofval_str
           mofmom = moment(mofval)
        } else {
            mofval = mo_ss
            mofmom = moment()
        }
        */

        let TIME_NO = false



        return (<DatePicker showTime={TIME_NO} onChange={onChange} value={mofmom} />)


    }
    renderCad({ input: { onChange, value }, showTime }){
        let param1 =  "1974-01-14"
        console.log('svj30*** FPD  value start')
        console.log(value)
        console.log('svj30*** FPD  value start')


        return (

            <Field 
            id="dateOfBirth"
            name="dateOfBirth"
                className="form-control"
                component={this.svcadCurryCom(param1, this)}
            />
        )


    }
    /*svf4 end*/
    
    render(){
        console.log('sv... SVCDnaStepFormBus 1 2 3')
        const { handleSubmit, pristine, error,reset, submitting } = this.props
        //const { initialValues,load, handleSubmit,loadGeneTemplate,  pristine, reset, submitting, submit, startSubmit } = this.props 
       // const { id, gene} = initialValues
       /*svj15 start*/
       const {countryTypes, isdcodeTypes, genderTypes,stateTypes} = this.props.my_data_geo
        const {renderCad} = this
       /*svj15 end*/
        const me = this 
        //me.gene = gene
        let initialValues = this.props.initialValues

        console.log(this.props)

        const {det} = this.props
        
        if(det && det.phone.length > 0){
            initialValues = det
        }

        let {customerId} = det

        return (
            <div>
                    <form  onSubmit={handleSubmit}>
                            <div className="rev-row">
                                <div className="card card--raised with-shadow">
                                    <p className="right-sd-content"> <text> Enter Details Now </text></p>

                                        <div className="form-group">
                                            <label htmlFor="id"> ID</label>
                                            
                                                <Field
                                            
                                                id="id"
                                                    name="id"
                                                    type="text"
                                                    placeholder="id"
                                                    component="input"
                                                    className="form-control"
                                                />
                                            

                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="fname"> First Name</label>
                                            
                                                <Field
                                            
                                                    id="fname"
                                                    name="fname"
                                                    type="text"
                                                    placeholder="John"
                                                    component={renderField}
                                                    className="form-control"
                                                />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="lname"> Last Name</label>
                                            <Field
                                                    id="lname"
                                                    name="lname"
                                                    type="text"
                                                    placeholder="Glen"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                                <label htmlFor="dateOfBirth"> SVF4 Date Of Birth</label>
                                                <Field
                                                        id="dateOfBirth"
                                                        name="dateOfBirth"
                                                        type="text"
                                                        placeholder="1979-05-18"
                                                        component={renderCad}
                                                        className="form-control"
                                                />
                                    
                                         </div>
                                        {/*  
                                        
                                         <div className="form-group">
                                            <label htmlFor="dateOfBirth"> Date Of Birth</label>
                                            <Field
                                                    id="dateOfBirth"
                                                    name="dateOfBirth"
                                                    type="text"
                                                    placeholder="1982-01-19"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        */}
                                       
                                        <div className="form-group">
                                                <label htmlFor="gender" > Gender</label>
                                                <Field  component="select" id="gender"   name="gender"  className="form-control" >
                                                
                                                    <option value="">Select Gender Type</option>
                                                    {
                                        
                                                
                                        genderTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="email"> Email Address</label>
                                            <Field
                                                    id="email"
                                                    name="email"
                                                    type="text"
                                                    placeholder="john123@yahoo.com"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="address"> Address </label>
                                            <Field
                                                    id="address"
                                                    name="address"
                                                    type="text"
                                                    placeholder="790 J St, Lincoln"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="city"> City</label>
                                            <Field
                                                    id="city"
                                                    name="city"
                                                    type="text"
                                                    placeholder="Lincoln"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="gene"> Zip Code</label>
                                            <Field
                                                    id="zipcode"
                                                    name="zipcode"
                                                    type="text"
                                                    placeholder="95648"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                                <label htmlFor="country" > Country</label>
                                                <Field  component="select" id="country"   name="country"  className="form-control" >
                                                
                                                <option value="">Select Country</option>
                                                    {
                                        
                                                
                                        countryTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                                        </div>
                                        {/*  
                                         <div className="form-group">
                                                <label htmlFor="country" > Country</label>
                                                <Field  component="select" id="country"   name="country"  className="form-control" >
                                                
                                                    <option value="">Select Country</option>
                                                    {
                                        
                                                
                                        countryTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                                        </div>
                                        <div className="form-group">
                                        
                                            <label htmlFor="dcountry">Country </label>
                                            <Field id="dcountry"  name="dcountry" onChange={me.dcountryChange} component="select">

                                                <option  value="">Select Country</option>
                                                {
                                                    dcountries.map ((o, idx)=>{

                                                        return ( <option  value={o.value}>{o.name}</option>)
                                                    })
                                                }

                                            </Field>

                                        </div>
                                            */}
                                         <div className="form-group">
                                            <label htmlFor="state"> STATE(2 letter)</label>
                                            <Field
                                                    id="state"
                                                    name="state"
                                                    type="text"
                                                    placeholder="ca"
                                                    component="input"
                                                    className="form-control"
                                            />
                                        </div>
                                        <div className="form-group">
                                                <label htmlFor="isdcode" > ISD Code</label>
                                                <Field  component="select" id="isdcode"   name="isdcode"  className="form-control" >
                                                
                                                <option value="">Select PhoneCalling /ISD Code</option>
                                                    {
                                        
                                                
                                        isdcodeTypes.map(  (o, idx)=>(  <option value={o.name+'('+o.value+')'} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                                        </div>
                                        {/* 
                                         <div className="form-group">
                                                <label htmlFor="isdcode" > ISD Code</label>
                                                <Field  component="select" id="isdcode"   name="isdcode"  className="form-control" >
                                                
                                                    <option value="">Select PhoneCalling /ISD Code</option>
                                                    {
                                        
                                                
                                        isdcodeTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                                    
                                                    
                                                    
                                                
                                                )}
        
                                                    </Field>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="isdcode"> ISD Code</label>
                                            <Field
                                                    id="isdcode"
                                                    name="isdcode"
                                                    type="text"
                                                    placeholder="+1"
                                                    component="input"
                                                    className="form-control"
                                            />
                                        </div>
                                        */}
                                        <div className="form-group">
                                            <label htmlFor="phone"> Phone</label>
                                            <Field
                                                    id="phone"
                                                    name="phone"
                                                    type="text"
                                                    placeholder="916-645-6360"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                    </div>
                            </div>

                            <div>
               
        <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/myaccountSV/${customerId}/myaddressList`}> SVCancel   </Link></SVAButton>
        
               <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
          Save(CreateOrModify)
        </button>  
        <SVAButton onClick={(e)=>me.reloadPageSV(customerId,this) } style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" >Reload</SVAButton>
           
         </div>
                    </form>
            </div>
        )
                    
                    

    }
}



const selector = formValueSelector(SVADFORM)
/*
let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }
  */

const adForm  = reduxForm({
    form:SVADFORM,
    validate:validate,
   
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(CreateAddressFormFormBus)
let CreateAddressFormFormBusCom =connect((state=>{
    const { svaddressdetView} = state
    let plucked = state.movies  
    //let o = {initialValues:plucked.adData }
    let o = {initialValues:svaddressdetView.my_data_addressdet}
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet start ')
    
    //selector(state, 'id')
    console.log('sv info')
    console.log(o)
    console.log('sv*******************CrateAddressForm shoul getmy_data_addressdet end ')
    
    return o
   // return plucked.adData
}),{
    //load:loadAdAction,
   // load:loadPrdAdDataDB,
    //load:loadCountriesAction,
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(adForm)


export default CreateAddressFormFormBusCom
//const CreateAddressFormFormBusCom  =x